import { Heading, Stack, Flex, Box, Skeleton } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { GroupMembersData, TeamMembersData } from '@/components/ui/features/team/data';
import {
  TeamMemberCard,
  TeamMemberCardFallback,
} from '@/components/ui/features/team/TeamGroup/components/TeamMemberCard';

export interface ITeamBlockProps {
  group: string;
}

export const TeamGroup: FC<ITeamBlockProps> = ({ group }) => {
  const { t } = useTranslation();

  return (
    <Stack gap={10}>
      <Box>
        <Heading as="h3" fontSize={{ base: '4xl', lg: '5xl' }}>
          {t(`team.${group}`)}
        </Heading>
      </Box>
      <Flex flexWrap="wrap" justifyContent="flex-start" columnGap="2" rowGap={20}>
        {GroupMembersData[group].map((member) => (
          <TeamMemberCard member={TeamMembersData[member]} key={TeamMembersData[member].name} />
        ))}
      </Flex>
    </Stack>
  );
};

export const TeamGroupFallback: FC = ({ ...rest }) => (
  <Stack gap={10}>
    <Box>
      <Skeleton w="20%" h={['2.3rem', null, 9]} mt="24px" />
    </Box>
    <Flex flexWrap="wrap" justifyContent="space-around" columnGap="2" rowGap={20} {...rest}>
      {Array.from({ length: 4 }, (_, i) => (
        <TeamMemberCardFallback key={i} />
      ))}
    </Flex>
  </Stack>
);
